# frozen_string_literal: true

module Engine
  module Game
    module G1837
    end
  end
end
